import React from 'react'
import { motion } from 'framer-motion'
import { HelpCircle, Mail } from 'lucide-react'
import { runAllTests } from '../utils/tests'

const HelpPage = () => {
  const faqs = [
    { q: 'How do I submit an event?', a: 'Use the Submit Event page; listings are moderated within 24 hours.' },
    { q: 'How are marketplace payments handled?', a: 'Secure payments with escrow; funds released when buyer confirms receipt.' },
    { q: 'How do I report an issue?', a: 'Email hello@littleeddieaudio.com with details and links.' }
  ]
  const [testResults, setTestResults] = React.useState<string[]>([])
  const runTests = () => {
    const r = runAllTests()
    setTestResults([`Passed: ${r.passed}, Failed: ${r.failed}`, ...r.details])
  }
  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-20">
        <div className="container-max max-w-4xl mx-auto">
          <motion.div className="text-center mb-10" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="text-4xl font-display font-bold text-white mb-3">Help & Support</h1>
            <p className="text-white/70">Answers to common questions and how to get in touch.</p>
          </motion.div>
          <div className="space-y-4">
            {faqs.map((f, i) => (
              <motion.div key={f.q} className="glass-card p-6" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }} viewport={{ once: true }}>
                <div className="flex items-start space-x-3">
                  <HelpCircle className="text-le-accent mt-1" size={20} />
                  <div>
                    <h3 className="text-white font-semibold mb-1">{f.q}</h3>
                    <p className="text-white/70">{f.a}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
          <div className="text-center mt-10">
            <a href="mailto:hello@littleeddieaudio.com" className="btn-secondary inline-flex items-center space-x-2"><Mail size={18} /><span>Contact Support</span></a>
          </div>

          <div className="glass-card p-6 mt-8">
            <div className="flex items-center justify-between">
              <h3 className="text-white font-semibold">Diagnostics</h3>
              <button className="btn-secondary" onClick={runTests}>Run Unit Tests</button>
            </div>
            {testResults.length > 0 && (
              <ul className="mt-3 text-white/80 text-sm list-disc pl-5 space-y-1">
                {testResults.map((t, i) => (<li key={i}>{t}</li>))}
              </ul>
            )}
          </div>
        </div>
      </section>
    </div>
  )
}

export default HelpPage

